import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

let isRefreshing = false;
let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;

    if (status === 402) {
      const detail = error.response?.data?.detail;
      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent("pro-required", {
            detail: typeof detail === "string" ? detail : "This feature requires DutyTrack Pro.",
          })
        );
      }
      return Promise.reject(error);
    }

    const isAuthEndpoint =
      original?.url?.includes("/auth/refresh") ||
      original?.url?.includes("/auth/login") ||
      original?.url?.includes("/auth/me");

    if (status === 401 && original && !original._retry && !isAuthEndpoint) {
      original._retry = true;
      try {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshPromise = axios.post(
            `${BACKEND_URL}/api/auth/refresh`,
            {},
            { withCredentials: true }
          );
        }
        await refreshPromise;
        isRefreshing = false;
        refreshPromise = null;
        return api(original);
      } catch (refreshError) {
        isRefreshing = false;
        refreshPromise = null;
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n, currency = "CAD") =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency }).format(n || 0);
